import script from "./EditTeacherAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTeacherAttendance.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__